<div class="container-fluid padMob" style="padding-left: 22px; padding-right: 20px; font-size: 14px;">
  <!-- Header -->
  <div class="row" style="padding-top: 10px; margin: 0px;">
    <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 0px">
      <div class="col-md-2 col-sm-12 col-xs-12"
        style="font-size: 30px; display: inline-block; vertical-align: bottom; padding-left: 0px;padding-right: 0px;">

        <span class="mobViewBtnBack mobView" style="font-size: 22px; margin-right: 10px;" *ngIf="!isShowRVoucher"
          (click)="backBtn()"><i class="fa fa-chevron-left"></i></span>
        <h2 class="lblHeader newHeader" style="padding-right: 15px; display: inline-block;margin:0px;">Accounts</h2>
        <!-- <span style="font-size: 12px; vertical-align: top; margin-left: -7px;" class="redText">Beta</span> -->

        <!-- <a class=" mobViewBtn mobView" *ngIf="isShowRVoucher"
          style="padding: 4px 0px 4px 14px;; font-size: 16px; margin-left: 10px; float: right; line-height: 1.66em; margin-right: 7px;"
          (click)="backToHomeBtn()" (cdkDropListDropped)="drop($event)">
          <i class="fa fa-bars " aria-hidden="true"></i>
        </a> -->
      
        <!-- Logout when When open in Edition type 4 -->
        <span class="btn mobView brdrRadius3" *ngIf="isShowLogoutBtn"
        style="margin-left: 7px !important; float: right; position: relative; padding: 4px 0px; top: 1px; line-height: 1.66em; font-size: 20px;" 
        (click)="logOut()">
            <i class="fa fa-power-off brownText" style="margin-right: 5px;"></i>
        </span>

        
        <a class="btn darkBlueButton brdrRadius3 mobView" [routerLink]="['/AcctReport']" target="{{isWeb ? '_blank' : '_self'}}"
          style="display:none!important;padding: 4px 6px 4px; font-size: 13px; margin-left: 10px; float: right; line-height: 1.66em;"
          title="Reports" *ngIf="right.Accts">
          <i class="fa fa-line-chart headerIcon" aria-hidden="true"></i>
        </a>

        <a class="btn btn-darkBlue"
          style="display: none; padding: 4px 9px 4px; font-size: 13px; margin-left: 10px; float: right; line-height: 1.66em;"
          (click)="GSTLedgerModal(gstLedgerSelect)" title="GST Ledgers" *ngIf="right.AcctsCfg">
          <i class="fa fa-cog headerIcon" aria-hidden="true" style="color: white;"></i>
        </a>

        <span class="btn darkBlueButton mobView" *ngIf="!isShowLogoutBtn"
        style="margin-left: 7px !important; float: right; position: relative;top: 8px; padding: 2px 9px;" 
        (click)="backToHomeBtn()">
            <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
        </span>

        <!-- <div class="col-md-6 col-6 col-sm-6 inLneBlk txtRight mobViewBtn mobView"> -->

        <!-- </div> -->
        <!-- <a class="mobViewBtn"> -->
        <!-- <a class=" btn btn-blue mobViewBtn mobView" (click)="isShowRVoucherMob = false; isShowRVoucher = true"
          style="padding: 4px 14px 4px; font-size: 13px; margin-left: 10px; float: right; line-height: 1.66em; margin-right: 7px;"
          *ngIf="(!isShowRVoucher && isShowRVoucherMob) || (!isShowRVoucher && !isShowRVoucherMob)">
          <i class="zmdi zmdi-chevron-left " style="color: white;"></i>
        </a> -->
        <!-- </a> -->
      </div>
      <div class="col-md-10 col-sm-12 col-sm-12 refresh" style="text-align: right; display: inline-block; padding: 5px 0px 0px 0px;">
        <!--<button class="btn btn-lg btn-outline-primary" (click)="open(mymodal)" style="border-radius: 25px; margin-top: 20px;">Voucher Entry</button>-->
        <!-- <a class="btn btn-orange webView" [routerLink]="['/profitandLoss']" target="_blank"  
                  style="padding: 5px 14px 4px; font-size: 14px; display: inline-block; line-height: 1.66em; 
                        margin-left: 10px; text-decoration: none; box-shadow: none !important;" title="Profit & Loss" >
                  <i class="fa fa-file-text-o headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> P & L
                </a> -->
        <!-- <a class="btn btn-yellow webView" [routerLink]="['/balanceSheet']" target="_blank"  
                  style="padding: 5px 14px 4px; font-size: 14px; display: inline-block; line-height: 1.66em; 
                        margin-left: 10px; text-decoration: none; box-shadow: none !important;" title="Balance Sheet" >
                  <i class="fa fa-balance-scale headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Balance Sheet
                </a> -->
        <!-- <div class="com-md-3 col-lg-3" style="display: inline-block; text-align: right; padding: 0px;"> -->

        <!-- </div> -->


        <!-- <div class="col-md-5 col-sm-5 col-xs-5" style="display: inline-block;font-size: 14px !important;padding-left: 0px;"> -->
        <!-- *ngIf="selectedFY != 'Other'" -->

        <!-- <select class="form-control" [(ngModel)]="selectedFY" (ngModelChange)="ddlchangeYear()"
          style="display: inline-block; padding: 1px 3px; font-size: 14px; cursor: pointer;"
          [style.width]="selectedFY == 'Other' ? '64px' : '130px'">
          <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
          <option value="Other">Other</option>
        </select> -->

        <!-- <div style="display: inline-block;width: 36%; vertical-align: bottom;" *ngIf="selectedFY == 'Other'">
          <div style="outline: none !important; display: inline-block; width: 55%; ">
            <input matInput readonly (focus)="picker.open()" [(ngModel)]="fromDate" [matDatepicker]="picker"
              class="form-control" (ngModelChange)="fn_ChangeDate()"
              style="display: inline-block; width:45%; outline: none !important; cursor: pointer; background: #FFF;">
            <mat-datepicker-toggle matSuffix [for]="picker" style="display: inline-block; outline: none !important;">
            </mat-datepicker-toggle>
            <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
          </div>
          <div
            style=" display: inline-block; display: inline-block; position: relative; left: -5px;vertical-align: -webkit-baseline-middle;">
            to</div>
          <div style="outline: none !important; display: inline-block; width: 40%; display: inline-block;">
            <input matInput readonly (focus)="picker2.open()" [matDatepicker]="picker2" class="form-control"
              [(ngModel)]="toDate" (ngModelChange)="fn_ChangeDate()"
              style="display: inline-block; width: 60%; outline: none !important; cursor: pointer; background: #FFF;">
            <mat-datepicker-toggle matSuffix [for]="picker2" style="display: inline-block; outline: none !important;">
            </mat-datepicker-toggle>
            <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
          </div>
        </div> -->
        <!-- </div> -->
        <!-- webview -->

        <span class="form-control formCtlFltr font12 webView bgwhite" style="cursor: pointer;padding-left: 0px; width: {{selectedFY == 'Other' ? '200px': '101px'}}; cursor: pointer; display: inline-block;text-align:left;padding-left: 5px; padding-top:5px;"  (click)="filterApply(dateFilter)">
          {{ selectedFY == 'Other' ? '' : 'FY'}} {{selectedFY == 'Other' ? '' : selectedFY}}
          <span *ngIf="selectedFY == 'Other'">
             {{fromDate | date :'dd-MMM-yy'}}  to  {{toDate | date :'dd-MMM-yy'}}
          </span>        
        </span>

        
        <!-- <select class="form-control font13 bdrrd5 bgwhite" [(ngModel)]="selectedFY"
          (change)="fn_changeFinancialYear($event)"
          style="padding-left: 0px; width: 130px; cursor: pointer; display: inline-block;">

          <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
          <option value="Other">Other</option>
        </select> -->

        <!-- mobview -->
        <!-- <select class="form-control font13  bgwhite mobView" [(ngModel)]="selectedFY"
          (ngModelChange)="fn_changeFinancialYear($event)"
          style="padding-left: 0px; width: 130px; cursor: pointer; display: inline-block;">

          <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
          <option value="Other">Other</option>
        </select> -->

        <!-- <div style="padding: 4px 10px; font-size: 14px; display: inline-block; line-height: 1.66em; 
                        margin-left: 10px; " (click)="refreshPeriod($event)">
          <i class="fa fa-refresh" aria-hidden="true" *ngIf="selectedFY=='Other'"></i>
        </div> -->

        <!-- <span class="refreshbtn" style="display: inline-block; 
        margin-left: 10px;cursor: pointer; " (click)="refreshPeriod($event)" title="Refresh Date">
          <i class="fa fa-refresh headerIcon " aria-hidden="true" *ngIf="selectedFY=='Other'"></i>
        </span> -->

        <div class="btn btn-orange mobView brdrRadius3"
          style="padding: 4px 8px 4px; font-size: 13px; margin-left: 10px; float: right; line-height: 1.66em; {{isMobileView ? 'float: left;' : ''}}"
          (click)="open(mymodal)" *ngIf="isShowVoucherBtn && right.AcctsVchrEntry" title="Enter Voucher">
          <i class="zmdi zmdi-plus headerIcon" style="margin-right: 5px;"></i> Enter Voucher
        </div>

        <!-- <a class="btn btn-darkBlue fntSz brdrRadius3 mobView" [routerLink]="['/AccountsSettings']" style="cursor: pointer; line-height: 20px;
          padding: 5px 10px; margin-left: 10px; float: right;" title="Settings" *ngIf="right.AcctsCfg">
          <i class="fa fa-cog" aria-hidden="true"></i>
        </a> -->

        <div class="btn orangeButton webView brdrRadius3 font13"
          style=" display: inline-block; margin-left: 10px;"
          (click)="openNewWindowVoucher('$event')" *ngIf="isShowVoucherBtn && right.AcctsVchrEntry" title="Enter Voucher">
          <i class="zmdi zmdi-plus headerIcon" style="margin-right: 5px;"></i> Enter Voucher
        </div>
        <a class="btn orangeButton webView font13" href="../../main.html#/Docs?M=8" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px; font-size: 13px; display: inline-block; line-height: 1.66em; 
                        display: none; margin-left: 10px; text-decoration: none !important; box-shadow: none !important;" title="POs"
          *ngIf="right.POEntry">
          <i class="fa fa fa-file-text-o headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> POs
        </a>
        <a class="btn orangeButton webView brdrRadius3 font13" href="../../main.html#/Docs?M=6" target="{{isWeb ? '_blank' : '_self'}}" style="display: inline-block; margin-left: 10px; text-decoration: none !important;"
          title="Purchases" *ngIf="right.InvoiceView">
          <i class="fa fa-shopping-cart headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Purchases
        </a>

        <a class="btn orangeButton webView brdrRadius3 font13" href="../../main.html#/Invoices" target="{{isWeb ? '_blank' : '_self'}}" style="display: inline-block; text-decoration: none !important; 
                        margin-left: 10px;"
          title="Invoices" *ngIf="right.InvoiceView">
          <i class="fa fa-file headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Sales
        </a>
        <!-- Credit Note -->
        <a class="btn btn-blue webView brdrRadius3 font13" href="../../main.html#/Docs?M=4" target="{{isWeb ? '_blank' : '_self'}}" style="display: inline-block;
                        display: none; margin-left: 10px; text-decoration: none !important; box-shadow: none !important;"
          title="Credit Notes" *ngIf="right.InvoiceView">
          <i class="fa fa-money" style="margin-right: 5px;" aria-hidden="true"></i> Cr Notes
        </a>

        <!-- Debit Notes-->
        <a class="btn btn-darkBlue webView font13" href="../../main.html#/Docs?M=5" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px; font-size: 13px; display: inline-block; line-height: 1.66em; 
                        display: none; margin-left: 10px; text-decoration: none !important; box-shadow: none !important;"
          title="Debit Notes" *ngIf="right.InvoiceView">
          <i class="fa fa-money" style="margin-right: 5px;" aria-hidden="true"></i> Db Notes
        </a>
        <!--HSN/CODE Router Link---[routerLink]="['/HsnList']"  [routerLink]="['/TagList']"-->

        <!-- <a class="btn darkBlueButton webView brdrRadius3 font12" [routerLink]="['/AccountsSettings']" style=" display: inline-block;padding: 5px 9px 5px !important; margin-left: 10px;" title="Settings" *ngIf="right.AcctsCfg">
          <i class="fa fa-cog" aria-hidden="true"></i>
        </a> -->
        <a class="btn darkBlueButton webView brdrRadius3 font12" [routerLink]="['/AcctReport']" target="{{isWeb ? '_blank' : '_self'}}" style=" display: inline-block;padding: 5px 7px 5px !important; margin-left: 10px;" title="Reports" *ngIf="right.Accts">
          <i class="fa fa-line-chart headerIcon" aria-hidden="true"></i>
        </a>
        <!-- <a class="btn darkBlueButton webView brdrRadius3 font12" [routerLink]="['/AccountsSettings']"  style=" display: inline-block;padding: 5px 9px 5px !important; margin-left: 10px;" title="Reports" *ngIf="right.AcctsCfg">
          <i class="fa fa-cog" aria-hidden="true"></i>
        </a> -->
        <span *ngIf="isLedgerSet" (click)="importLadger()" class="btn orangeButton font13" title="Import Ledgers"
            style="cursor: pointer; margin-left: 10px; margin-right: 10px; float: right; padding:5px 10px !important; {{isMobileView ? 'float: left;' : ''}}"><span><i
              class="zmdi zmdi-arrow-left-bottom font13" aria-hidden="true"></i></span>
          </span>

        <div class="btn orangeButton webView" style="padding: 4px 10px; font-size: 14px; display: none; line-height: 1.66em; 
                        margin-left: 10px; " (click)="GSTLedgerModal(gstLedgerSelect)" title="GST Ledgers"
          *ngIf="right.AcctsCfg">
          <i class="fa fa-cog headerIcon font13" aria-hidden="true"></i>
        </div>
        <span class="orangeButton webView font13" title="Back to Accounts Dashboard"
          style="display: inline-block; margin-left: 10px;" (click)="backBtn()"
          *ngIf="!isShowRVoucher">
          <i class="fa fa-chevron-left font13" style="margin-right: 3px;"></i> Back
        </span>
        <span class="form-control formCtlFltr font12 bgwhite" *ngIf="isMobileView" style="cursor: pointer;padding-left: 0px; width: {{selectedFY == 'Other' ? '200px': '101px'}}; cursor: pointer; display: inline-block;text-align:left;padding-left: 5px; padding-top:5px; {{isLedgerSet ? '' : 'margin-left: 10px;'}}"  (click)="filterApply(dateFilter)">
          {{ selectedFY == 'Other' ? '' : 'FY'}} {{selectedFY == 'Other' ? '' : selectedFY}}
          <span *ngIf="selectedFY == 'Other'">
             {{fromDate | date :'dd-MMM-yy'}}  to  {{toDate | date :'dd-MMM-yy'}}
          </span>        
        </span>
        <!-- <div class="mobViewBtn">
          <div (click)="isShowRVoucherMob = false; isShowRVoucher = true" class="btn btn-blue"
            style="margin-left: 15px; border-radius: 50%; padding: 0px; width: 30px; height: 30px; line-height: 30px;"
            *ngIf="(!isShowRVoucher && isShowRVoucherMob) || (!isShowRVoucher && !isShowRVoucherMob)">
            <i class="zmdi zmdi-chevron-left "></i>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <!-- Body -->
  <div class="row" style="padding-top: 20px; margin: 0px;">
    <div class="col-md-12" style="padding: 0px;">
      <!-- Left -->
      <div class="col-md-6" style="display: inline-block; padding: 0px;">
        <div>
          <app-heads [changingHead]="changingHeadValue" [accountDates]="accountDates"></app-heads>
        </div>

        <div class="webView" style="margin-top: 10px;">
          <a href="https://biziverse.com/support/support.html?abt=accounts" target="_blank" class="trngDarkBlueBtn">
            <i class="zmdi zmdi-help-outline" style="margin-right: 5px; font-size: 16px;position: relative;
            top: 2px;"></i> Training Materials
          </a>
          <span *ngIf="!showLearningMaterial && showOnBoarding" (click)="openHelpPage(11)" class="trngDarkBlueBtn" style="margin-left: 10px;">
            <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
          </span>
          <span (click)="openTrngModal()" class="trngDarkBlueBtn" style="margin-left: 10px;">
            <i class="fa fa-youtube-play" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Watch Training
          </span>
        </div>
      </div>


      <!-- Right -->
      <div class="col-md-6 pad0Mob"
        style="display: inline-block; vertical-align: top; margin-bottom: 20px; padding-right: 0px;">
        <div *ngIf="isShowRVoucher && !isShowRVoucherMob" style="margin-top: {{isMobileView ? '5px' : '0px'}};">
          <app-recent-vouchers [accountDates]="accountDates"></app-recent-vouchers>
        </div>
        <div class="mrgTop10 pad0Mob"
          *ngIf="(!isShowRVoucher && isShowRVoucherMob) || (!isShowRVoucher && !isShowRVoucherMob)">
          <app-ledger-record [changing]="changing" [accountDates]="accountDates"></app-ledger-record>
        </div>
        <div class="mobView" style="margin-top: 10px;">
          <a href="https://biziverse.com/support/support.html?abt=accounts" target="_blank" class="trngDarkBlueBtn">
            <i class="zmdi zmdi-help-outline" style="margin-right: 5px; font-size: 16px;position: relative;
            top: 2px;"></i> Training Materials
          </a>
          <span *ngIf="!showLearningMaterial && showOnBoarding" (click)="openHelpPage(11)" class="trngDarkBlueBtn" style="margin-left: 10px;">
            <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
          </span>
          <span (click)="openTrngModal()" class="trngDarkBlueBtn" style="margin-left: 10px;">
            <i class="fa fa-youtube-play" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Watch Training
          </span>
        </div>
      </div>
    </div>
  </div>

  <!--Voucher Entry Modal-->
  <ng-template #mymodal let-modal>
    <div class="modal-body" style="padding: 0px; background-color: #f8f8f8;"> 
      <app-voucher-entry (oncloseVchrModal)="closeModal($event)"></app-voucher-entry>
    </div>
  </ng-template>

  <!-- Invoice Status -->
  <ng-template #myInvoiceStatus let-modal>
    <div class="modal-body" style="padding: 0px;">
      <app-invoice-status></app-invoice-status>
    </div>
  </ng-template>

  <!--Expand Modal-->
  <ng-template #gstLedgerSelect let-modal>
    <!--Header-->
    <div class="modal-header">
      <div class="col-md-12 col-sm-12 col-12 pad0">
        <div class="row" style="margin: 0px;">
          <div class="col-md-10 col-sm-10 col-10" style="padding-left: 0px;">
            <h4 class="modal-title"><span id="ApntmntHdr" class="">GST Ledger Configuration</span></h4>
            
          </div>
          <div class="col-md-2 col-sm-2 col-2" style="padding: 0px;">
            <i class="closeMdl zmdi zmdi-close" data-dismiss="modal" style="float: right;"
              (click)="modal.dismiss('Cross click')"></i>
          </div>
        </div>
      </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="overflow-y: auto;">
      <!-- GST Locations -->
      <div class="col-md-12 col-sm-12 col-12 pad0">
        <span>
          GST :
        </span>
        <select class="form-control" style="display: inline-block; width: 200px; cursor: pointer;">
          <option>Select GST</option>
        </select>
      </div>
      <div class="col-md-12 col-sm-12 col-12 pad0">
        <!-- GST Out (Sales) -->
        <div class="col-md-4 col-sm-12 col-12 pad0" style="display: inline-block;padding-right: 15px;">
          <div style="margin-bottom: 7px;">
            <span style="font-size: 16px;" class="greenText">Sales (Output)</span>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 greenText" style="margin-bottom: 10px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST-Out :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.CGSTOut" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 col-12 pad0 greenText" style="margin-bottom: 7px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST-Out :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.SGSTOut" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 greenText" style="margin-bottom: 7px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST-Out :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.IGSTOut" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>
        </div>

        <!-- GST In (Purchase) webview -->
        <div class="col-md-4 col-sm-12 col-12 webView" style="display: inline-block;">
          <div style="margin-bottom: 7px;">
            <span style="font-size: 16px;" class="tealText">Purchase (Input)</span>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST-In :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.CGSTIn" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST-In :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.SGSTIn" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST-In :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.IGSTIn" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>
        </div>

        <!-- GST In (Purchase) mobview -->
        <div class="col-md-4 col-sm-12 col-12 mobView" style="padding: 0px 15px 0px 0px ;">
          <div style="margin-bottom: 7px;">
            <span style="font-size: 16px;" class="tealText">Purchase (Input)</span>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST-In :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.CGSTIn" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST-In :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.SGSTIn" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
            <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST-In :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
              <input class="form-control wid100" list="cgstOut" [(ngModel)]="GSTLedger.IGSTIn" placeholder="Select"
                [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important" id="cgstOut">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>
        </div>

        <!-- GST Reverse (Reverse Charge) webview -->
        <div class="col-md-4 col-sm-12 col-12 pad0 webView" style="display: inline-block;padding-left: 15px;">
          <div style="margin-bottom: 7px;">
            <span style="font-size: 16px; font-weight: 500; margin-bottom: 7px;" class="blueText">Reverse Charge
              (Output)</span>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 10px;">
            <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="cgstOutRev" [(ngModel)]="GSTLedger.CGSTRevOut"
                placeholder="Select" [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important" id="cgstOutRev">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 7px;">
            <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="sgstOutRev" [(ngModel)]="GSTLedger.SGSTRevOut"
                placeholder="Select" [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="sgstOutRev">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 7px;">
            <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="igstOutRev" [(ngModel)]="GSTLedger.IGSTRevOut"
                placeholder="Select" [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="igstOutRev">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>
        </div>

        <!-- GST Reverse (Reverse Charge) mobView -->
        <div class="col-md-4 col-sm-12 col-12 pad0 mobView" style="padding:0px 15px 0px 0px;">
          <div style="margin-bottom: 7px;">
            <span style="font-size: 16px; font-weight: 500; margin-bottom: 7px;" class="blueText">Reverse Charge
              (Output)</span>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 10px;">
            <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="cgstOutRev" [(ngModel)]="GSTLedger.CGSTRevOut"
                placeholder="Select" [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important" id="cgstOutRev">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 7px;">
            <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="sgstOutRev" [(ngModel)]="GSTLedger.SGSTRevOut"
                placeholder="Select" [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="sgstOutRev">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 7px;">
            <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST :
            </div>
            <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
              <input class="form-control wid100" list="igstOutRev" [(ngModel)]="GSTLedger.IGSTRevOut"
                placeholder="Select" [disabled]="isEditGSTLedger">
              <datalist style="left: 5px !important;" id="igstOutRev">
                <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
              </datalist>
            </div>
          </div>
        </div>

      </div>

    </div>
    <!--Footer-->
    <div class="" style="padding: 0px 0px 15px 15px; border: none; text-align: left; float: left;"
      *ngIf="!isEditGSTLedger">
      <span class="btn btn-save" style="padding: 5px 14px 4px; line-height: 1.66em; font-size: 14px;"
        (click)="saveGSTLedger()">
        <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
        <span>Save</span>
      </span>
      <span style="font-size: 12px; color: #777; margin-left: 10px; font-style: italic;">Please note that change in this configuration will only be reflected in new vouchers.</span>

    </div>
  </ng-template>

  <!--date filter mdl-->
<ng-template #dateFilter let-modal>
  <!--Header-->
  <div class="modal-header" style="padding-bottom:0px">
      <div class="col-md-12 col-sm-12 col-12">
          <div class="row">
              <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                  <h4 class="modal-title"><span id="ApntmntHdr">Select Period</span></h4>
              </div>
              <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
                  <i class="closeMdl zmdi zmdi-close" style="float: right; "
                      (click)="modal.dismiss('Cross click')"></i>
              </div>
          </div>
      </div>
  </div>
  <!--Body-->
  <div class="modal-body">
    <div class="col-md-12 col-sm-12 col-xs-12" *ngFor="let f of financialYears let i = index" style="padding: 0px;margin-bottom:10px;">
      <span class="{{changeColorUserList(i % 7, f.FY)}} brdrRadius3" style="display: inline-block; cursor: pointer; padding: 7px 12px; width: 100%; text-align: center;" (click)="changePeriod(f.FY, i)">
        FY {{f.FY}}
   </span>                         
  </div>
  <div class="col-md-12 col-sm-12 col-xs-12"  style="padding: 0px;margin-bottom:10px;">
    <span class="bz-drkBlueBtn-lb {{val == 13 ? 'bz-drkBlueBtn-lb-active' : ''}} brdrRadius3" style="display: inline-block; cursor: pointer; padding: 7px 12px; width: 100%; text-align: center; font-size: 15px;" (click)="changePeriod('Other', 13)">
      Other
  </span>                         
  </div>

  <div *ngIf="objPeriod.selectedPeriod == 'Other'" class="col-md-12 col-sm-12 col-xs-12"  style="padding: 0px;">
    <input [max]="toDate" matInput readonly [matDatepicker]="picker2" id="fromdate" (click)="picker2.open()" [(ngModel)]="fromDate" 
        style="cursor: pointer; font-size: 14px; border-bottom-width: 1px; margin-left: 8px; border-top: 0px; border-left: 0px; padding: 0px; border-right: 0px;width: 75px;">
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2 color="primary"></mat-datepicker>

    <label style="font-size: 14px;">to :</label>

    <input [min]="fromDate"  matInput readonly [matDatepicker]="picker3" id="toDate" (click)="picker3.open()" [(ngModel)]="toDate" 
        style="cursor: pointer; font-size: 14px; border-bottom-width: 1px; margin-left: 8px; border-top: 0px; border-left: 0px; padding: 0px; border-right: 0px;width: 75px;">
    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle> 
    <mat-datepicker #picker3 color="primary"></mat-datepicker>                       
  </div> 

  <div *ngIf="objPeriod.selectedPeriod == 'Other'" class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 10px;
  padding: 0px; border: none; text-align: left; float: left; padding-top: 0px;" (click)="serach('$event')">
    <span class="btn btn-orange brdrRadius3" style="padding: 0px;line-height: 30px !important;padding: 5px 6px;font-size: 13px !important;color:#fff; border: 1px solid #e88421;  background:#e88421;border-radius: 25px;padding: 0px 15px;">
      <span>
        <i aria-hidden="true" class="zmdi zmdi-search" style="font-size: 16px;position: relative;top: 1px;"></i>
      </span><span  style="margin-left: 10px;">Search</span></span>
  </div>
  </div>
  <!--Footer-->
 
</ng-template>

</div>

<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>
